import gql from 'graphql-tag'

export const GET_BOX = gql`
query BoxTypes {
    boxTypes {
      isSuccessful
      message
      boxTypes {
        text
        hasRelation
        companyId
      }
    }
  }`

export const BOX_MUTATION_CREATE = gql`
mutation MutationType($input: CreateLookupInputSimple!) {
    createBoxType(input: $input) {
      isSuccessful
      message
      boxType {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }`

export const BOX_MUTATION_DELETE = gql`
  mutation DeleteBoxType($input: DeleteLookupInputSimple!) {
    deleteBoxType(input: $input) {
      isSuccessful
      message
      boxType {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }`

export const BOX_MUTATION_UPDATE = gql`
  mutation UpdateBoxType($input: UpdateLookupInputSimple!) {
    updateBoxType(input: $input) {
      isSuccessful
      message
      boxType {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }`
